import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import WordCloud from 'react-d3-cloud';
import '../assets/stylesheet/utiliti.scss';
import baseUrl from '../services/baseUrl';
import ApiRequest from '../services/apiService';
import ScreenLoader from './screenLoader';
import { useNavigate } from 'react-router-dom';
import { ShowToastUtil } from '../utilities/showToastUtil';
import GetUserData from '../utilities/getUserDetails';

function CustomerExperienceSearch({ }) {
    const [searchTerm, setSearchTerm] = useState(localStorage.getItem('wordCloudSearchTerm') || '');
    const [selectedFilters, setSelectedFilters] = useState(localStorage.getItem('wordCloudSelectedFilters') || []);
    const [quickFilter, setQuickFilter] = useState(localStorage.getItem('quickFilter') || '');
    const [projectFilter, setProjectFilter] = useState(localStorage.getItem('projectFilter') || '');
    const [touchpointFilter, setTouchpointFilter] = useState(localStorage.getItem('touchpointFilter') || '');
    const [sobFilter, setSobFilter] = useState(localStorage.getItem('sobFilter') || '');
    const [toDate, setToDate] = useState(localStorage.getItem('toDate') || '');
    const [fromDate, setFromDate] = useState(localStorage.getItem('fromDate') || '');
    const [wordCloudData, setWordCloudData] = useState([]);
    const [IsLoading, setIsLoading] = useState(false);
    const [userData, setUserData] = useState(GetUserData() || {});

    const fetchWordCloudData = async (searchTerm, selectedFilters) => {
        selectedFilters = Array.isArray(selectedFilters) ? selectedFilters : [];
        localStorage.setItem('wordCloudSearchTerm', searchTerm);
        localStorage.setItem('wordCloudSelectedFilters', selectedFilters);
        setIsLoading(true);
        try {
            const filterValues = {
                Promoters: 10,
                Passives: 8,
                Detractors: 6,
            };

            const PpdFiltersQuery = selectedFilters
                .map((filter) => filterValues[filter])
                .filter((value) => value !== undefined)
                .join(",");

                const params = new URLSearchParams({
                searchTerm: searchTerm || "",
                filters: PpdFiltersQuery,
                quickFilterRange: quickFilter,
                queryMode: 7,
                fromDate: localStorage.getItem('fromDate') || fromDate,
                toDate: localStorage.getItem('toDate') || toDate,
                touchpointFilter: touchpointFilter,
                sobFilter: sobFilter,
                projectFilter: localStorage.getItem('projectFilter') || projectFilter,
                userRole: userData.UserRole,
                userProject: userData.ProjectIds,
                userCode: userData.UserCode,
            });

            const url = `${baseUrl()}/nps/GetNpsDashboardChartsData?${params.toString()}`;

            const responseData = await ApiRequest({
                apiLink: url,
                method: "GET"
            });
            if (responseData.IsSuccess && responseData.Data) {
                setWordCloudData(responseData.Data.WordCloudCharts || []);
                setIsLoading(false);
            } else {
                console.error("API Response Error:", responseData);
            }
        } catch (error) {
            console.error("Error fetching filtered word cloud data:", error);
        }
    };

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            fetchWordCloudData(searchTerm, selectedFilters);
        }, 1800);

        return () => clearTimeout(timeoutId);
    }, [searchTerm, selectedFilters]);


    const handleFilterClick = (type) => {
        setSelectedFilters(prevFilters => {
            // Ensure prevFilters is an array
            const newFilters = Array.isArray(prevFilters)
                ? (prevFilters.includes(type)
                    ? prevFilters.filter(filter => filter !== type)
                    : [...prevFilters, type])
                : [type];  // If it's not an array, initialize it with the clicked filter.
            fetchWordCloudData(searchTerm, newFilters);
            return newFilters;
        });
    };
    

    const handleClear = () => {
        setSearchTerm('');
        setSelectedFilters([]);
        fetchWordCloudData('', []);
        localStorage.removeItem('wordCloudSearchTerm');
        localStorage.removeItem('wordCloudSelectedFilters');
    };

    const categoryColors = {
        6: "#f10000",
        10: "#008000",
    };

    const processedTags = wordCloudData.flatMap(entry => {
        const word = entry.Word.toLowerCase().replace(/[^a-z0-9]/gi, "");
        const color = categoryColors[entry.Rating] || "#ffb62f";
        const customerName = entry.CustomerName || "";
        const id = entry.id || "";
        return word ? { value: word, count: entry.Frequency, color, customerName, id } : null;
    }).filter(Boolean);

    const aggregatedTags = processedTags.reduce((acc, tag) => {
        if (acc[tag.value]) {
            acc[tag.value].count += tag.count;
        } else {
            acc[tag.value] = { ...tag };
        }
        return acc;
    }, {});

    const finalTags = Object.values(aggregatedTags);
    const navigate = useNavigate();
    const handleTagClick = (word) => {
        setSearchTerm(word);
        fetchWordCloudData(word, selectedFilters);
        if(projectFilter!=''){ // for 3 projects
            navigate('/textWordCloud');
            window.location.reload();
        }
        else{
            ShowToastUtil('Please select a project for detailed view', 'warning'); 
        }
    };
    return (
        <>
            {IsLoading ? (
                <>
                    <div className="screenLoader">
                        <ScreenLoader />
                    </div>
                </>
            ) : (<>
                <div className="col-md-4">
                    <div className='row px-2'>
                        <div className='col-12 mb-2 text-center'>
                            <Button
                                variant={selectedFilters.includes('Promoters') ? "success ppdFiltersBtn" : "success"}
                                className={`btn-sm px-2 me-2 mb-2 ${selectedFilters.includes('Promoters') ? 'active' : 'inactive'}`}
                                onClick={() => handleFilterClick('Promoters')}
                            >
                                Promoters
                            </Button>
                            <Button
                                variant={selectedFilters.includes('Passives') ? "warning ppdFiltersBtn" : "warning"}
                                className={`btn-sm px-2 me-2 mb-2 ${selectedFilters.includes('Passives') ? 'active' : 'inactive'}`}
                                onClick={() => handleFilterClick('Passives')}
                            >
                                Passives
                            </Button>
                            <Button
                                variant={selectedFilters.includes('Detractors') ? "danger ppdFiltersBtn" : "danger"}
                                className={`btn-sm px-2 me-2 mb-2 ${selectedFilters.includes('Detractors') ? 'active' : 'inactive'}`}
                                onClick={() => handleFilterClick('Detractors')}
                            >
                                Detractors
                            </Button>
                        </div>
                        <div className='col-12'>
                            <div className="did-floating-label-content">
                                <input
                                    className="did-floating-input"
                                    type="search"
                                    placeholder=" "
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.currentTarget.value)}
                                />
                                <label className="did-floating-label">Keyword</label>
                            </div>
                        </div>
                        <div className='col-12 mb-2 text-center'>
                            <Button
                                variant="secondary"
                                className='btn-sm px-3 me-2 mb-2'
                                onClick={handleClear}
                            >
                                Clear
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="col-md-8">
                    <div className="row">
                        <div className="col-12 text-center">
                            <div>
                                <WordCloud
                                    data={finalTags.map((tag) => ({
                                        text: tag.value,
                                        value: tag.count,
                                        color: tag.color
                                    }))}
                                    fontSize={(word) => Math.max(Math.log2(word.value) * 25, 30)}
                                    spiral="rectangular"
                                    rotate={()=>0}
                                    padding={10}
                                    fill={(d) => d.color}
                                    onWordClick={(event, d) => handleTagClick(d.text)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>)}
        </>
    );
}

export { CustomerExperienceSearch };
